import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as policies from '../../policies'

export const RESOURCE = {
  payload: {
    description:
      'A grouping of related company policies (e.g. People & Workplace, Everyday Security, State Employment Supplements).',
    dimension: policies.RESOURCE.payload,
    level: 0,
    name: 'Policy Area',
    partialId: PartialId.Standard.create('policy_area'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
